import { useEffect, useState } from "react";
import { Alert, Button, Card, Form, Row, Col } from "react-bootstrap";
import Loader from "../../../helpers/Loader";
import {
  BsFillFileEarmarkPdfFill,
  BsFillPlusCircleFill,
  BsFillTrashFill,
} from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert2";
import { setMessageAction } from "../../../actions/messageActions";
import { axiosDownloadFile } from "../../../helpers/axiosDownloadFile";
import { cursoEstado } from "../../../helpers/constantes";
import {
  INSCRIPCION_CURSO_ENDPOINT,
  INSCRIPCION_CURSO_PDF_ENDPOINT,
} from "../../../helpers/endpoints";
import useAxios from "../../../hooks/useAxios";
import InscripcionACursosTabla from "./InscripcionACursosTabla";
import InscripcionCursosCard from "./InscripcionCursosCard"; // Importar el nuevo componente
import { AVISO_GESTION_MATERIAS_HTML } from "../../utils/AvisoGestionMaterias";
import ToggleCardTable from "../../utils/ToggleCardTable";
import "../../../assets/css/custom.scss";

const regIncripcion = (dato) => {
  return { ...dato, btnText: "", disabled: false };
};
const regEliminar = (dato) => {
  return { ...dato, btnText: "", disabled: false };
};

export default function InscripcionCursos() {
  const [materiasDisponibles, setMateriasDisponibles] = useState(null);
  const [materiasInscripto, setMateriasInscripto] = useState(null);
  const [isInscripcionWebFinalizada, setIsInscripcionWebFinalizada] =
    useState(true);
  const [viewMode, setViewMode] = useState("card"); // Estado para controlar la vista
  const carreraSect = useSelector((state) => state.carr.carreraSect);
  const dispatch = useDispatch();
  const { request } = useAxios();
  const [loading, setLoading] = useState(true); // inicia en true

  const mensajeSistema = (message, tipo) => {
    dispatch(
      setMessageAction({
        type: tipo,
        mensaje:
          message ||
          "En este momento no podemos procesar la solicitud. Intente más tarde",
      }),
    );
  };

  const getMateriasIncripcion = async () => {
    try {
      setLoading(true); // muestra loader al iniciar la petición
      const resp = await request({
        url: `${INSCRIPCION_CURSO_ENDPOINT}/${carreraSect?.alumnoPrograma}`,
      });
      let disponible = resp.filter((d) => d.accion === cursoEstado.DISPONIBLE);
      setMateriasDisponibles(disponible.map((d) => regIncripcion(d)));
      let inscripto = resp.filter((d) => d.accion !== cursoEstado.DISPONIBLE);
      setMateriasInscripto(inscripto.map((d) => regEliminar(d)));

      if (resp.some((d) => !d.inscripcionHabilitada)) {
        setIsInscripcionWebFinalizada(false);
      }
    } catch (error) {
      setMateriasDisponibles([]);
      setMateriasInscripto([]);
      mensajeSistema(error.message, "ERROR");
    } finally {
      setLoading(false); // oculta loader al finalizar
    }
  };

  const deleteMateriasIncripcion = ({ cursoSelected }) => {
    let seleccion = {
      ...cursoSelected.data,
      btnText: "Procesando...",
      disabled: true,
    };

    swal
      .fire({
        title: `Materia: ${cursoSelected.data.descripcionCurso}`,
        html: `
          <p>Horario: ${cursoSelected.data.horarios || "Horario no informado"}</p>
          ${AVISO_GESTION_MATERIAS_HTML}
        `,
        icon: "question",
        confirmButtonText: `Eliminar curso`,
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        dangerMode: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          setMateriasInscripto((prev) =>
            prev.map((item) => (item.id === seleccion.id ? seleccion : item)),
          );

          const curso = {
            id: seleccion.id,
            alumnoProgramaId: carreraSect.alumnoPrograma,
            cursoTipoClase: seleccion.cursoTipoClase,
            accion: seleccion.accion,
          };

          try {
            const resp = await request({
              url: INSCRIPCION_CURSO_ENDPOINT,
              method: "put",
              body: {
                id: seleccion.id,
                alumnoProgramaId: carreraSect.alumnoPrograma,
                cursoTipoClase: seleccion.cursoTipoClase,
                accion: seleccion.accion,
              },
            });
            setMateriasInscripto((prev) =>
              prev.filter((m) => m.id !== seleccion.id),
            );
            setMateriasDisponibles((prev) => [...prev, regIncripcion(resp)]);
            mensajeSistema(
              `Se eliminó el curso ${resp.descripcionCurso}`,
              "success",
            );
          } catch (error) {
            console.error("Error:", error);
            setMateriasInscripto((prev) =>
              prev.map((item) =>
                item.id === seleccion.id ? regEliminar(item) : item,
              ),
            );
            mensajeSistema(error.message, "ERROR");
          }
        }
      });
  };

  const postMateriasIncripcion = ({ cursoSelected }) => {
    let seleccion = {
      ...cursoSelected.data,
      btnText: "Procesando...",
      disabled: true,
    };
    swal
      .fire({
        title: `Materia: ${cursoSelected.data.descripcionCurso}`,
        html: `
          <p>Horario: ${cursoSelected.data.horarios || "Horario no informado"}</p>
          ${AVISO_GESTION_MATERIAS_HTML}
        `,
        icon: "question",
        confirmButtonText: `Inscribirme`,
        cancelButtonText: "Cancelar",
        showCancelButton: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          setMateriasDisponibles((prev) =>
            prev.map((item) => (item.id === seleccion.id ? seleccion : item)),
          );

          try {
            const resp = await request({
              url: `${INSCRIPCION_CURSO_ENDPOINT}/${carreraSect?.alumnoPrograma}`,
              method: "post",
              body: {
                id: seleccion.id,
                cursoTipoClase: seleccion.cursoTipoClase,
              },
            });
            setMateriasDisponibles((prev) =>
              prev.filter((m) => m.id !== seleccion.id),
            );
            setMateriasInscripto((prev) => [...prev, regEliminar(resp)]);
            mensajeSistema(
              `Te has inscripto a ${resp.descripcionCurso}`,
              "success",
            );
          } catch (error) {
            console.error("Error: ", error);
            setMateriasDisponibles((prev) =>
              prev.map((item) =>
                item.id === seleccion.id ? regIncripcion(item) : item,
              ),
            );
            mensajeSistema(error?.message, "ERROR");
          }
        }
      });
  };

  useEffect(() => {
    if (carreraSect?.alumnoPrograma) {
      getMateriasIncripcion();
    }
  }, [carreraSect?.alumnoPrograma]);

  const pdf = () => {
    axiosDownloadFile(
      `${INSCRIPCION_CURSO_PDF_ENDPOINT}/${carreraSect?.alumnoPrograma}`,
      "cursosInscriptos",
    );
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {!isInscripcionWebFinalizada && (
        <Alert className="shadow m-5 p-3" variant="warning">
          La inscripción web ha finalizado. Si deseas añadir una materia, por
          favor contacta al departamento de alumnos.
        </Alert>
      )}

      <Card className="shadow m-5 p-3">
        <h2 className="text-center mt-3 mb-3">Materias disponibles</h2>
        <div className="d-flex justify-content-end mb-3">
          <ToggleCardTable viewMode={viewMode} setViewMode={setViewMode} />
        </div>

        {viewMode === "table" ? (
          <InscripcionACursosTabla
            datos={materiasDisponibles}
            accion={postMateriasIncripcion}
            btnIcon={<BsFillPlusCircleFill />}
            btnVariant={"btn btn-success btn-sm"}
            btnTitle={"Inscribirse"}
            ocultar={false}
          />
        ) : (
          <InscripcionCursosCard
            datos={materiasDisponibles}
            accion={postMateriasIncripcion}
            btnIcon={<BsFillPlusCircleFill />}
            btnVariant={"success"}
            btnTitle={"Inscribirse"}
          />
        )}
      </Card>

      <Card className="shadow m-5 p-3">
        <h2 className="text-center m-3 ">Materias inscriptas</h2>
        <div style={{ textAlign: "right" }}>
          <Button
            className="bt btn-info mb-2"
            style={{ textAlign: "left", fontWeight: "bold" }}
            onClick={() => pdf()}
            disabled={
              materiasInscripto?.length === 0 || materiasInscripto === null
                ? true
                : false
            }
          >
            {<BsFillFileEarmarkPdfFill />} Comprobante inscripción{" "}
          </Button>
        </div>

        {viewMode === "table" ? (
          <InscripcionACursosTabla
            datos={materiasInscripto}
            accion={deleteMateriasIncripcion}
            btnIcon={<BsFillTrashFill />}
            btnVariant={"btn btn-danger btn-sm"}
            btnTitle={"Borrarse"}
            ocultar={true}
          />
        ) : (
          <InscripcionCursosCard
            datos={materiasInscripto}
            accion={deleteMateriasIncripcion}
            btnIcon={<BsFillTrashFill />}
            btnVariant={"danger"}
            btnTitle={"Borrarse"}
          />
        )}
      </Card>
    </>
  );
}
